module.exports = __webpack_public_path__ + "img/text_lavadora_botellas.5cf602f3.png";